module.exports = __webpack_public_path__ + "static/img/clientBg.ea577165.png";